import React from 'react';
import { connect } from 'react-redux';

import { answerQuestion } from '../../../../../_actions/questionnaire.actions';

const YesNo = ({ question, dispatch }) => {
  return <>
    <h6 className="card-title">{question.linkId}. {question.text || 'Enter your question.'}</h6>

    <div className="form-check">
      <input
        onChange={(e) => { dispatch(answerQuestion(question, e.target.value)) }}
        id={`yesno_${question.linkId}_yes`} className="form-check-input" type="radio" name={`yesno_${question.linkId}`} value="Yes" />
      <label className="form-check-label" htmlFor={`yesno_${question.linkId}_yes`}>Yes</label>
    </div>

    <div className="form-check">
      <input
        onChange={(e) => { dispatch(answerQuestion(question, e.target.value)) }}
        id={`yesno_${question.linkId}_no`} className="form-check-input" type="radio" name={`yesno_${question.linkId}`} value="No" />
      <label className="form-check-label" htmlFor={`yesno_${question.linkId}_no`}>No</label>
    </div>
  </>;
}

export default connect()(YesNo);